import React, { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';
import GenericThemeProvider from '../../shared/GenericThemeProvider';
import {
  Container, Grid, StatusContainer, UsageContainer,
} from './styles';
import SolutionCards from './SolutionCards';
import HPUsageDataWidget from '../HPUsageDataWidget';
import useAccountApiCall from '../../hooks/useAccountApiCall';
import useDeviceCacheApiCall from '../../hooks/useDeviceCacheApiCall';
import StatusWidget from '../StatusWidget';
import Banner from './Banner';

const ConsolidatedDashboard = ({ stack, shell }) => {
  const { dashboardUsageDataUnitFromOrg } = useFlags();

  const { authProvider, localization: { country: urlCountry } } = shell;

  const currentDate = useMemo(() => new Date(Date.now()), []);

  const accountCall = useAccountApiCall({
    init: dashboardUsageDataUnitFromOrg,
  });

  const country = dashboardUsageDataUnitFromOrg ? (accountCall.data?.regionId || urlCountry) : urlCountry;

  const deviceCache = useDeviceCacheApiCall({
    authProvider,
    stack,
    init: true,
  });

  return (
    <GenericThemeProvider>
      <Container data-testid="consolidated-dashboard">
        <Banner data-testid="banner-container" deviceCache={deviceCache} />

        <Grid>
          <SolutionCards
            deviceCache={deviceCache}
          />

          <StatusContainer data-testid="status-container">
            <StatusWidget
              stack={stack} deviceCache={deviceCache}
              consolidatedPortal
            />
          </StatusContainer>

          <UsageContainer data-testid="hp-usage-data-container">
            <HPUsageDataWidget
              data-testid="addons-hp-data-usage-widget"
              currentDate={currentDate}
              country={country}
              consolidatedPortal
            />
          </UsageContainer>
        </Grid>
      </Container>
    </GenericThemeProvider>
  );
};

ConsolidatedDashboard.defaultProps = {
  stack: 1,
};

ConsolidatedDashboard.propTypes = {
  stack: PropTypes.number,
  shell: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default ConsolidatedDashboard;
